import { connect } from "react-redux";
import WorkInstructionsOverview from "./WorkInstructionsOverview"
import { fetchAllWorkInstructions } from "../../../../redux/actions/wi_actions"
import { fetchAllUsers } from "../../../../redux/actions/user_actions"
import { fetchAllTags } from "../../../../redux/actions/tag_actions"

const mapStateToProps = (state, props) => {
    return ({
        workInstructions: Object.values(state.work_instructions.all),
        users: Object.values(state.users),
        gridlabel: props.gridlabel
    });
}

const mapDispatchToProps = (dispatch) => {
    return ({
        fetchAllWorkInstructions: (cancelToken) => dispatch(fetchAllWorkInstructions(cancelToken)),
        fetchAllUsers: () => dispatch(fetchAllUsers()),
        fetchAllTags: () => dispatch(fetchAllTags())
    });
}

export default connect(mapStateToProps, mapDispatchToProps)(WorkInstructionsOverview);